export class ElasticFilter {
  type: string
  field: string

  constructor(type: string, field: string) {
    this.type = type
    this.field = field
  }
}

export class TermFilter extends ElasticFilter {
  matches: string

  constructor(key: string, value: string) {
    super('term', key)
    this.matches = value
  }
}

export class NumberFilter extends ElasticFilter {
  matches: number

  constructor(key: string, value: number) {
    super('term', key)
    this.matches = value
  }
}

export class RangeFilter extends ElasticFilter {
  from: number
  to: number

  constructor(from: number, to: number, field: string = '@timestamp') {
    super('range', field)
    this.from = from
    this.to = to
  }
}
